import * as React from 'react'
import styled from 'styled-components'
import { isAndroid, isIOS, isMobile } from 'react-device-detect'
import AppleBadge from '@components/shared/icons/AppleBadge'
import AndroidBadge from '@components/shared/icons/AndroidBadge'
import { OutlineOnFocusVisible } from '@components/shared'
import { config } from 'react-awesome-styled-grid'

export default function AppStoreBadgeButtons (): React.ReactNode {
  if (isAndroid && isMobile) {
    // returns true if os type is Android && if device type is mobile or tablet
    return (
      <BadgeLink
        href={'https://dipsea.app.link/download-play-store'}
        target='_blank'
        rel='noopener noreferrer'
      >
        <AndroidBadge width='100%' />
      </BadgeLink>
    )
  } else if (isIOS && isMobile) {
    // returns true if os type is iOS &&  if device type is mobile or tablet
    return (
      <BadgeLink
        href={'https://dipsea.app.link/download-app-store'}
        target='_blank'
        rel='noopener noreferrer'
      >
        <AppleBadge width='100%' />
      </BadgeLink>
    )
  } else {
    // fall back return both
    return (
      <Row>
        <BadgeLink
          href={'https://dipsea.app.link/download-app-store'}
          target='_blank'
          rel='noopener noreferrer'
        >
          <AppleBadge width='100%' />
        </BadgeLink>

        <BadgeLink
          href={'https://dipsea.app.link/download-play-store'}
          target='_blank'
          rel='noopener noreferrer'
        >
          <AndroidBadge width='100%' />
        </BadgeLink>
      </Row>
    )
  }
}

const Row = styled.div<any>`
  display: flex;
`

const BadgeLink = styled.a<any>`
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  max-width: 170px;
  outline: none;
  &:hover {
    opacity: 0.5;
  }

  margin: 0 5px 10px;
  ${(props: any): any => config(props).media.md`
    margin: 0 10px 10px;
  `}

  ${OutlineOnFocusVisible};
`
